export default __webpack_public_path__ + "static/media/logo-proloco.654133a0.png";